import { IPageConfig } from "../services/nav/Interfaces";

export const ZeosPageConfig: IPageConfig[] = [
  {
    pageId: 1,
    pageMessage:
      "Enter your details to create your account. We'll use this information to personalize your experience and connect you to energy-saving insights.",
    pageTitle: "Welcome to ZEOS-AI! Let's get started with your account.",
    slug: "account-setup",
  },
  {
    pageId: 2,
    pageMessage:
      "We use public databases to help prefill your company information where possible. This ensures accuracy and speeds up your setup.",
    pageTitle: "Input Company Information",
    slug: "company",
  },
  {
    pageId: 3,
    pageMessage:
      "This helps us understand how your building uses energy and tailor recommendations accordingly.",
    pageTitle: "Property Information",
    slug: "property",
  },
  {
    pageId: 5,
    pageMessage:
      "Answer a few quick questions to personalize your experience. You can skip this now and return at any time.",
    pageTitle: "Property Survey",
    slug: "survey",
  },
  {
    pageId: 4,
    pageMessage:
      "Short, focused surveys help ZEOS-AI sharpen project recommendations and incentive matching for your properties. Take one, take several, or skip them all. You can always complete them later from your dashboard.",
    pageTitle: "Optional Property Surveys",
    slug: "surveys",
  },
  {
    pageId: 6,
    pageMessage:
      "By linking your utility account, ZEOS-AI can analyze real-time and historical energy usage to unlock maximum value and savings.",
    pageTitle: "Connect your utility account for the best experience",
    slug: "uapi",
  },
  {
    pageId: 7,
    pageMessage: "Uapi Confirmation - PAGE MESSAGE MISSING",
    pageTitle: "Uapi Confirmation - PAGE TITLE MISSING",
    slug: "uapi-confirm",
  },
  {
    pageId: 8,
    pageMessage:
      "To get the most out of ZEOS-AI, we need some basic energy usage information. You can also upload your past utility bills for easier data input.",
    pageTitle: "Enter your energy details manually",
    slug: "uapi-manual",
  },
  {
    pageId: 9,
    pageMessage: "",
    pageTitle: "Your personalized assessment is ready",
    slug: "summary",
  },
  {
    pageId: 10,
    pageMessage:
      "Please check your email for a 6-digit verification code and enter it below to verify your account.",
    pageTitle: "Verify Your Email",
    slug: "account-verification",
  },
  {
    pageId: 11,
    pageMessage: "Please set a secure password for your account.",
    pageTitle: "Email Successfully Verified",
    slug: "account-password",
  },
  {
    pageId: 12,
    pageMessage:
      "Please enter and confirm your new password to reset your account.",
    pageTitle: "Reset Your Password",
    slug: "reset-password",
  },

  // NEW ROUTES ADDED BELOW
  {
    pageId: 14,
    pageMessage: "",
    pageTitle: "",
    slug: "portfolio",
  },
  {
    pageId: 18,
    pageMessage: "",
    pageTitle: "",
    slug: "dashboard",
  },
  {
    pageId: 19,
    pageMessage: "",
    pageTitle: "",
    slug: "explore",
  },
  {
    pageId: 20,
    pageMessage: "",
    pageTitle: "",
    slug: "solar",
  },
  {
    pageId: 21,
    pageMessage: "",
    pageTitle: "",
    slug: "battery",
  },
  {
    pageId: 22,
    pageMessage: "",
    pageTitle: "",
    slug: "ev",
  },
  {
    pageId: 23,
    pageMessage: "",
    pageTitle: "",
    slug: "carbon",
  },
  {
    pageId: 24,
    pageMessage: "",
    pageTitle: "",
    slug: "building",
  },
  {
    pageId: 25,
    pageMessage: "",
    pageTitle: "",
    slug: "incentives",
  },
  {
    pageId: 26,
    pageMessage: "",
    pageTitle: "",
    slug: "compliance",
  },
  {
    pageId: 27,
    pageMessage: "",
    pageTitle: "",
    slug: "projects",
  },
  {
    pageId: 28,
    pageMessage: "",
    pageTitle: "",
    slug: "screening",
  },
];
